export const employeeHiringLink = {
  PHONE_PLACEHOLDER: '0000 0000',
  DOCUMENT_PLACEHOLDER: '0.0000.0000',
  Document: 'CI/DIMEX',
  'Owner identification document': 'CI/DIMEX del titular',
};
